export const customLinksConst = {
    RELOAD: 'RELOAD_CUSTOM_LINKS'
};
